import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from 'react-metrics';

import WithCompare from './compare-container';
import Drawer from '../../page/components/drawer';
import Button from '../../ui/components/button';
import CompareBox from './compare-box';
import CompareBoxDetail from './compare-box-detail';
import Link from '../../shared/components/hyperlink';
import { withError } from '../../shared/components/error-boundary';
import { Grid, Column } from '../../ui/components/grid';

import Icon from '../../ui/components/icon';

import './compare-drawer.less';

function CompareDrawer(props) {
    const [collapse, setCollapse] = useState(false);
    const { compareProducts, toggleCompareProduct, clearCompareProducts, compareSlots, error, headerComp } = props;
    const compact = true;
    const full = compareProducts.length === compareSlots;
    const emptyItems = full
        ? []
        : Array.from(Array((error ? compareSlots - 1 : compareSlots) - compareProducts.length).keys());
    const currentCompareProducts = error && full ? compareProducts.slice(0, 3) : [...compareProducts];

    useEffect(() => {
        if (document) {
            const chatButton = document.getElementById('concierge');
            if (chatButton) chatButton.style.bottom = collapse ? '90px' : '220px';
        }

        return () => {
            if (document) {
                const chatButton = document.getElementById('concierge');
                if (chatButton) chatButton.style.bottom = '50px';
            }
        };
    }, [collapse, error]);

    const shouldRender = compareProducts.length >= 0;

    const collapseTool = (isCollapsed, productCount, slotsCount) => (
        <div className="collapse" onClick={() => setCollapse(!isCollapsed)}>
            {productCount}/{slotsCount}
            <Icon name={collapse ? 'up' : 'down'} size={18} />
        </div>
    );

    return (
        <>
            {headerComp(compareProducts.length > 0, collapse)}
            {shouldRender && (
                <Drawer
                    className={'drawer-compare-container'}
                    open={compareProducts.length > 0}
                    onClose={() => { }}
                    position="bottom"
                    collapse={collapse}
                >
                    <Grid className="drawer-compare compare-label">
                        <Column className="compare-actions" desktop={2} small={2} hide={['small', 'xs', 'xxs']}>
                            Compare Models
                        </Column>
                        {!collapse && (
                            <>
                                {currentCompareProducts
                                    .slice()
                                    .reverse()
                                    .map((product, i) =>
                                        compact ? (
                                            <Column
                                                desktop={2}
                                                small={2}
                                                mobile={2}
                                                key={product.sku}
                                                columnClass={`order-${i + 1}`}
                                            >
                                                <CompareBox
                                                    product={product}
                                                    toggleCompareProduct={products =>
                                                        toggleCompareProduct(products, true)
                                                    }
                                                />
                                            </Column>
                                        ) : (
                                            <Column desktop={2} small={2} mobile={2} key={product.sku}>
                                                <CompareBoxDetail
                                                    product={product}
                                                    toggleCompareProduct={products =>
                                                        toggleCompareProduct(products, true)
                                                    }
                                                />
                                            </Column>
                                        )
                                    )}
                                {error && (
                                    <Column desktop={2} small={2} mobile={2}>
                                        <div className="compare-box error">
                                            Only products from the same category can be compared.
                                        </div>
                                    </Column>
                                )}
                                {emptyItems.map(k => (
                                    <React.Fragment key={k}>
                                        {compact && (
                                            <Column desktop={2} small={2} mobile={2}>
                                                <div className="compare-box" />
                                            </Column>
                                        )}
                                        {!compact && (
                                            <Column desktop={2} small={2} mobile={2}>
                                                <div className={`compare-box ${k === 0 ? 'add-new' : 'empty'}`}>
                                                    <span>{k === 0 && <Link>add new similar</Link>}</span>
                                                </div>
                                            </Column>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}

                        <Column className="compare-actions" desktop={2} small={2} hide={['small', 'xs', 'xxs']}>
                            {collapseTool(collapse, compareProducts.length, compareSlots)}
                            <MetricsElement
                                element={'span'}
                                data-metrics-event-name="linkClick"
                                data-metrics-event="e_linkClick"
                                data-metrics-link-id={`compareProducts:${compareProducts.length}`}
                            >
                                <Button
                                    icon="arrow_right"
                                    disable={!(compareProducts.length > 1)}
                                    text="COMPARE"
                                    linkComponent={<Link to="/compare">COMPARE</Link>}
                                    color="white"
                                />
                            </MetricsElement>
                            <Button
                                text="CLEAR ALL"
                                icon="x"
                                type="tertiary"
                                color="white"
                                action="remove"
                                onClick={clearCompareProducts}
                            />
                        </Column>
                        <div className="mobile-actions">
                            <MetricsElement
                                className={'metrics-wrapper'}
                                element={'span'}
                                data-metrics-event-name="linkClick"
                                data-metrics-event="e_linkClick"
                                data-metrics-link-id={`compareProducts:${compareProducts.length}`}
                            >
                                <Button
                                    className="btn-compare"
                                    type="tertiary"
                                    disable={!(compareProducts.length > 1)}
                                    text="compare"
                                    color="white"
                                    variation="left"
                                    linkComponent={<Link to="/compare">COMPARE</Link>}
                                />
                            </MetricsElement>
                            {collapseTool(collapse, compareProducts.length, compareSlots)}
                        </div>
                    </Grid>
                </Drawer>
            )}
        </>
    );
}

CompareDrawer.defaultProps = {
    compareSlots: 4,
    headerComp: () => { }
};

CompareDrawer.propTypes = {
    compareSlots: PropTypes.number,
    compareProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
    toggleCompareProduct: PropTypes.func.isRequired,
    clearCompareProducts: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
};

export default WithCompare(withError(CompareDrawer));
